import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser,
  getFetcherHeader
} from '../../modules/ajio-fetch/utils.js';
import fetcher from '../../modules/ajio-fetch';
import { EDDAction } from '../constants/index.js';
import { getHostName } from '../../utils/sisUtils';
// import "whatwg-fetch";
import { readCookie } from '../../components/common/Cookie';
import { addProductToWishlist } from '../../wishlist/actions/wishlist.js';
import { deleteBulkItemsFromCart } from '../../cart/actions/cart.js';
import { getAjioWalletEarnData } from '../../myaccount/actions/ajiowallet.js';
import { hideModal } from '../../actions/modal.js';
import { ModalTypes } from '../../constants/index.js';
import { getPincodeFromCookie, getServiceOrNonServicabilityItems } from '../utils/utils.js';
import { setErrorObject } from '../../actions/shared/HTTPError';
import properties from '../../modules/ajio-util/properties';
import isNode from '../../modules/ajio-util/isNode.js';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../components/common/CheckUserStatus';
import luxeScreen from '../../refresh/constants/luxeScreenType';

const login_url = properties.getProperty('loginPageURL');
const api_url = properties.getProperty('apiUrl');
const endPoints = require('../../modules/ajio-util/endpoints');

export function resetDeliveryDetails(productCode, isExchangeRquest = false) {
  return {
    type: EDDAction.RESET.DELIVERY_DETAILS,
    productCode,
    isExchangeRquest
  };
}

export function setPincodeModal(status) {
  return {
    type: EDDAction.SET.PINCODE_MODAL,
    status
  };
}

export function setMoveToClosetModal(status) {
  return {
    type: EDDAction.SET.MOVE_TO_CLOSET,
    status
  };
}

function fetchDeliveryDetailsRequest({ pinCode, productCode }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.REQUEST,
    pinCode,
    productCode
  };
}

function fetchDeliveryDetailsFailure() {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.FAILURE
  };
}

function fetchDeliveryDetailsSuccess({ pinCode, productDetails, productCode, servicability }) {
  return {
    type: EDDAction.FETCH.DELIVERY_DETAILS.SUCCESS,
    pinCode,
    productDetails,
    productCode,
    servicability
  };
}
function fetchProductServiceabilityRequest() {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.REQUEST
  };
}

function fetchProductServiceabilitySuccess(payload) {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.SUCCESS,
    payload
  };
}
function fetchProductServiceabilityFailure() {
  return {
    type: EDDAction.FETCH.PRODUCT_SERVICEABILITY_DETAILS.FAILURE
  };
}
function dayDifference(delivery_date) {
  const todayDate = new Date();
  const deliveryDate = new Date(delivery_date);
  // calculate time difference
  const time_difference = deliveryDate.getTime() - todayDate.getTime();

  // calculate days difference by dividing total milliseconds in a day
  const days_difference = time_difference / (1000 * 60 * 60 * 24);
  return days_difference;
}

export function fetchDeliveryDetails(
  pincode = getPincodeFromCookie(),
  code,
  quantity = 1,
  isExchange = false
) {
  return (dispatch, getState) => {
    if (!pincode) {
      return;
    }
    const {
      product: { selectedSizeCode = code }
    } = getState();
    // const params = {
    //   productCode: selectedSizeCode,
    //   postalCode: pincode,
    //   quantity: 1,
    //   IsExchange: false,
    // };
    const { location: { href = '' } = {} } = window;
    const {
      pdp: { screenName = '', screenType = '' }
    } = luxeScreen;
    const pcode = code || selectedSizeCode;
    dispatch(fetchDeliveryDetailsRequest({ pinCode: pincode, productCode: pcode }));
    
    let api = encodeURI(
        `/api/edd/checkDeliveryDetails?productCode=${pcode}&postalCode=${pincode}&quantity=${quantity}&IsExchange=${isExchange}`
      );
    if(isNode()){
      // if the call is from the node server we will use the api url to make the call
      api = api_url + api
    }
    return fetcher(api, fetchGetJSONReqOpts({ credentials: 'include' }))
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [
            {
              codEligible: false,
              productCode: pcode,
              reasonForNotServiceability: 'NS',
              servicability: false
            }
          ],
          servicability,
          pinCode,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response;

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          dispatch(fetchDeliveryDetailsFailure());
        } else if (apiResponseStatusCode === 0) {
          if (!isNode()) {
            // gtmEventPush({
            //   event: 'edd_submit',
            //   event_category: 'product details interactions',
            //   event_action: 'estimate delivery date',
            //   event_label: 'submit',
            //   pincode: pinCode,
            //   cod_eligible: productDetails[0].codEligible.toString(),
            //   servicable: productDetails[0].servicability,
            //   EDD:
            //     productDetails[0].eddUpper !== '' ? dayDifference(productDetails[0].eddUpper) : '',
            //   store_type: getHostName(href),
            //   user_status: signInCheck() ? 'logged in' : 'not logged In',
            //   time_of_the_day: '',
            //   login_type: signInCheck() ? 'logged in' : 'not logged In',
            //   page_name: screenName,
            //   page_type: screenType
            // });
          }
          dispatch(
            fetchDeliveryDetailsSuccess({
              pinCode,
              productDetails,
              productCode: selectedSizeCode,
              servicability
            })
          );
        }
        dispatch(hideModal(ModalTypes.EDD_PINCODE));
        dispatch(setPincodeModal(false));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(fetchDeliveryDetailsFailure());
        // what will happen if fail
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            dispatch(setPincodeModal(false));
            // dispatch(showErrorMessage(errorObj));
            dispatch(hideModal(ModalTypes.EDD_PINCODE));
            return Promise.reject(errorObj);
          })
          .catch(error => {
            // handle this error
            // dispatch(showErrorMessage(errorObj));
            return Promise.reject(error);
          });
      });
  };
}

export function fetchProductServiceability(
  pincode = getPincodeFromCookie(),
) {
  return (dispatch, getState) => {
    let userId = decodeURIComponent(readCookie('CI')) !== 'null' ? decodeURIComponent(readCookie('CI')) : '';
    if (!userId) {
      return;
    }
    const {
      product: { productDetails }
    } = getState();

  dispatch(fetchProductServiceabilityRequest());
  const api = encodeURI(`/api/edd/checkProductServiceability`);
  let body = {
    itemDetail: {
      brand: productDetails?.brandName,
      brick: productDetails?.brickCode,
      catalogId: productDetails?.catalog,
      category: productDetails?.brickCategory,
      mrp: productDetails?.wasPriceData?.value,
      name: productDetails?.brickName,
      optionCode: productDetails?.request?.optionCode,
      salesPrice: productDetails?.price?.value,
      subCategory: productDetails?.brickSubCategory
    },
    pincode: pincode,
    userId: userId
  };
  return fetcher(api, fetchGetJSONReqOpts({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  }))
    .then(fetchGetJSONResHandler)
    .then(response => {
      const {
        status: { statusCode: apiResponseStatusCode = 0 } = {} 
      } = response;
      
      const { result: { cod = { }, returnWindow = { }, showEmi = false } = {} }  = response;
      if (apiResponseStatusCode != 0 && apiResponseStatusCode !=2 ) {
        const errorObj = {
          errorType: 'info',
          message: 'Oops! something went wrong, Please try again'
        };
        dispatch(setErrorObject(errorObj));

        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        dispatch(fetchProductServiceabilityFailure());
      } else if(apiResponseStatusCode === 2){
        dispatch(fetchProductServiceabilityFailure());
      } else{
        dispatch(
            fetchProductServiceabilitySuccess({
              cod, 
              returnWindow,
              showEmi
            })
          );
      }
      dispatch(hideModal(ModalTypes.EDD_PINCODE));
      dispatch(setPincodeModal(false));
      return Promise.resolve(response);
    })
    .catch(error => {
      dispatch(fetchProductServiceabilityFailure());
      // what will happen if fail
      const statusCode = getErrorStatusCode(error);
      return errorParser(error, statusCode)
        .then((errorObj = {}) => {
          dispatch(setPincodeModal(false));
          // dispatch(showErrorMessage(errorObj));
          dispatch(hideModal(ModalTypes.EDD_PINCODE));
          return Promise.reject(errorObj);
        })
        .catch(error => {
          // handle this error
          // dispatch(showErrorMessage(errorObj));
          return Promise.reject(error);
        });
    });
 };
};


function fetchCartItemsEDDRequest() {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.REQUEST
  };
}

function fetchCartItemsEDDFailure() {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.FAILURE
  };
}

function checkServiceabilityAPIFailed() {
  return {
    type: 'CHECK_SERVICEABILITY_API_FAILED'
  };
}

function checkServiceabilityAPISuccess() {
  return {
    type: 'CHECK_SERVICEABILITY_API_SUCCESS'
  };
}

function fetchCartItemsEDDSuccess({
  pincode,
  productDetails = [],
  servicability = false,
  codEligible = false
}) {
  return {
    type: EDDAction.FETCH.CART_ITEMS_DELIVERY_DETAILS.SUCCESS,
    pincode,
    productDetails,
    servicability,
    codEligible
  };
}
function getFieldValues(request) {
  if (request) {
    var { U: userName = '', C: cartId = '', A: accessToken } = request.cookies;
  } else {
    var userName = readCookie('A');
    var cartId = readCookie('C');
    var accessToken = readCookie('A');
  }
  return {
    userName,
    cartId,
    accessToken
  };
}

export function fetchCartItemsEDD({ request, id } = {}) {
  return (dispatch, getState) => {
    const { userName, cartId, accessToken } = getFieldValues(request);
    const headerInfo = getFetcherHeader(request);
    const {
      cart: { deliveryInfo: { deliveryAddress: { postalCode: cartPostalCode } = {} } = {} } = {},
      order: { deliveryInfo: { deliveryAddress: { postalCode: orderPostalCode } = {} } = {} } = {},
      addressBook: { postalCode },
      flags: { enablePriorityDeliveryPreOrder= 'OFF', enableAjioMemberShipProgram = 'OFF', ajioMemberShipConfig } = {},
      variants: {enablerushdelivery}
    } = getState();

    const channelType = request.device.type === 'phone' ? 'MSITE' : 'WEB';
    const enableAjioMemberShipProgramme =
      (enableAjioMemberShipProgram === 'ON' &&
        ajioMemberShipConfig?.isEnableForCart &&
        channelType === 'MSITE') ||
      false;
    const membershipQuery = `&isMembershipActivated=${enableAjioMemberShipProgramme}`;
    const enablePriorityDelivery = enablePriorityDeliveryPreOrder === 'ON';
    const rushDeliveryEnable = enablerushdelivery?.key?.toUpperCase() === 'ON' ? enablerushdelivery?.payload : false;
    const activePincode = cartPostalCode || orderPostalCode || postalCode;
    if (!activePincode) {
      return Promise.resolve();
    }
    console.log("FETCH CART EDD REQUEST", request.device.type)
    dispatch(fetchCartItemsEDDRequest());

    const queryParams = `${userName}/carts/${id ||
      cartId}/checkServiceableCart?pincode=${activePincode}&priorityDeliveryEnable=${enablePriorityDelivery}&rushDeliveryEnable=${rushDeliveryEnable}${membershipQuery}`;
    const url = `${endPoints.get('checkServiceableCart')}/${queryParams}`;

    return fetcher(
      url,
      fetchGetJSONReqOpts({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${accessToken}`,
          ...headerInfo
        }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [],
          servicability = false,
          codEligible = false,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response || {};

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(fetchCartItemsEDDFailure());
          dispatch(checkServiceabilityAPIFailed());
          dispatch(setErrorObject(errorObj));
        } else if (apiResponseStatusCode === 0) {
          dispatch(
            fetchCartItemsEDDSuccess({
              pincode: activePincode,
              productDetails,
              servicability,
              codEligible
            })
          );
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        // handle client
        return errorParser(error, getErrorStatusCode(error))
          .then(error => {
            return Promise.reject(error);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      });
  };
}

export function fetchCartItemsEDDFromClient(pincode, isRecursivelyCalling = false) {
  return (dispatch, getState) => {
    dispatch(fetchCartItemsEDDRequest());
    const api = encodeURI(`/api/edd/checkServiceableCart?pincode=${pincode}`);
    return fetcher(api, fetchGetJSONReqOpts({ credentials: 'include' }))
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          productDetails = [],
          servicability = false,
          codEligible = false,
          status: { statusCode: apiResponseStatusCode = 1 } = {}
        } = response || {};

        if (apiResponseStatusCode === 1) {
          const errorObj = {
            errorType: 'info',
            message: 'Oops! something went wrong, Please try again'
          };
          dispatch(fetchCartItemsEDDFailure());
          dispatch(checkServiceabilityAPIFailed());
          dispatch(setErrorObject(errorObj));

          const timeout = setTimeout(() => {
            dispatch(setErrorObject({}));
            clearTimeout(timeout);
          }, 5000);
          return Promise.resolve(response);
        }
        if (apiResponseStatusCode === 0) {
          dispatch(
            fetchCartItemsEDDSuccess({ pincode, productDetails, servicability, codEligible })
          );
          return Promise.resolve(response);
        }
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(fetchCartItemsEDDFailure());
        const statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode)
          .then((errorObj = {}) => {
            if (statusCode === 401 && !isRecursivelyCalling) {
              return tokenReCreateParser(statusCode, errorObj)
                .then(() => {
                  return Promise.resolve(fetchCartItemsEDDFromClient(pincode, true)(dispatch));
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            }
            return Promise.reject(errorObj);
          })
          .catch(error => {
            return Promise.reject(error);
          });
      });
  };
}

function moveAllNonDeliverableItemToClosetRequest() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.REQUEST
  };
}
// function moveAllNonDeliverableItemToClosetFailure() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.FAILURE
//   }
// }
function moveAllNonDeliverableItemToClosetSuccess() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.SUCCESS
  };
}

// function moveAllNonDeliverableItemToClosetRequest() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.REQUEST
//   }
// }
function moveAllNonDeliverableItemToClosetFailure() {
  return {
    type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.FAILURE
  };
}
// function moveAllNonDeliverableItemToClosetSuccess() {
//   return {
//     type: EDDAction.MOVE.ALL_NON_DELIVERABLE_ITEMS_TO_CLOSET.SUCCESS
//   }
// }

function removeNonDeliverableItem({ activePincode, productCode }) {
  return {
    type: EDDAction.REMOVE.NON_VELIVERABLE_ITEM,
    activePincode,
    productCode
  };
}

export function moveAllNonDeliverableItemToCloset() {
  return async (dispatch, getState) => {
    dispatch(moveAllNonDeliverableItemToClosetRequest());
    const {
      edd: { eddDetails, activePincode },
      cartItem
    } = getState();
    const items = getServiceOrNonServicabilityItems(cartItem, eddDetails, activePincode, false);
    const promiseArray = [];
    try {
      const entryNumbers = [];
      for (let i = 0; i < items.length; i++) {
        const addToWishList = dispatch(addProductToWishlist(items[i].code, false));
        promiseArray.push(addToWishList);
        entryNumbers.push(items[i].entryNumber);
        removeNonDeliverableItem({ activePincode, productCode: items[i].productCode });
      }
      const bulkDelete = dispatch(deleteBulkItemsFromCart(entryNumbers));
      await Promise.all([...promiseArray, bulkDelete]);
    } catch (err) {
      dispatch(moveAllNonDeliverableItemToClosetFailure());
      window.location = '/cart';
      console.log(err);
    }
    dispatch(moveAllNonDeliverableItemToClosetSuccess());
    window.location = '/cart';
  };
}
